import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllIndicators(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.type_stock) {
    params.append('type_stock_id', filters.type_stock);
  }
  const response = await axios.get(
    `${API_URL}catalogos/stock/indicator?${params}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getAllPackages(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.type_stock) {
    params.append('type_stock_id', filters.type_stock);
  }
  const response = await axios.get(`${API_URL}catalogos/package?${params}`);
  const data = response.data.doc.data;
  return data;
}

export async function getPackageById(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.init_date) {
    params.append('init_date', filters.init_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  if (filters.status_id) {
    params.append('status_id', filters.status_id);
  }
  if (filters.package_id) {
    params.append('package_id', filters.package_id);
  }
  const response = await axios.get(`${API_URL}catalogos/stock?${params}`);
  const data = response.data.doc.data;
  return data;
}

export async function getProviderById(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.id) {
    params.append('id', filters.id);
  }
  const response = await axios.get(`${API_URL}catalogos/provider?${params}`);
  const data = response.data.doc.data;
  return data;
}

export async function getProtectedImageUrl(
  filename: string
): Promise<string | null> {
  if (!filename) return null;

  const token = localStorage.getItem('token');
  try {
    const response = await axios.get(
      `${API_URL}catalogos/package/files/${filename}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );

    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error('Error al obtener imagen protegida:', error);
    return null;
  }
}

export async function getSelectTypeStock() {
  const response = await axios.get(`${API_URL}catalogos/stock/type`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = `${row.name}`;
    row.value = row.id;
  });
  return dataSelect;
}

export async function getSelectTypeProvider() {
  const response = await axios.get(`${API_URL}catalogos/provider`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = `${row.name}`;
    row.value = row.id;
  });
  return dataSelect;
}

export async function addProduct(values: any, products: any) {
  const body = { ...values };

  const formData = new FormData();

  if (products?.length) {
    formData.append('stock', JSON.stringify(products));
  }

  if (body.typeStock !== undefined && body.typeStock !== null) {
    formData.append('type_stock_id', body.typeStock.toString());
  }

  if (body.typeSupplier !== undefined && body.typeSupplier !== null) {
    formData.append('provider_id', body.typeSupplier.toString());
  }

  if (body.description) {
    formData.append('description', body.description);
  }

  if (body.purchasePrice !== undefined && body.purchasePrice !== null) {
    formData.append('input_price', body.purchasePrice.toString());
  }

  if (body.salePrice !== undefined && body.salePrice !== null) {
    formData.append('output_price', body.salePrice.toString());
  }

  if (body.location) {
    formData.append('location', body.location);
  }

  if (body.avatar instanceof File) {
    formData.append('image', body.avatar);
  }

  const response = await axios({
    method: 'post',
    url: `${API_URL}catalogos/package`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response;
}

export async function getInventaryById(id: number) {
  const response = await axios.get(`${API_URL}catalogos/package/${id}`);
  const data = response.data.doc.data;
  return data;
}

export async function updProduct(values: any) {
  const body = { ...values };

  const formData = new FormData();

  if (body.type_stock_id !== undefined && body.type_stock_id !== null) {
    formData.append('type_stock_id', body.type_stock_id.toString());
  }

  if (body.provider_id !== undefined && body.provider_id !== null) {
    formData.append('provider_id', body.provider_id.toString());
  }

  if (body.description) {
    formData.append('description', body.description);
  }

  if (body.input_price !== undefined && body.input_price !== null) {
    formData.append('input_price', body.input_price.toString());
  }

  if (body.output_price !== undefined && body.output_price !== null) {
    formData.append('output_price', body.output_price.toString());
  }

  if (body.image instanceof File) {
    formData.append('image', body.image);
  }

  const response = await axios({
    method: 'put',
    url: `${API_URL}catalogos/package/${body.id}`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response;
}
